export const NODE_HEIGHT_PX = 40;
export const NODE_GAP_PX = 16;
